import Vue from "vue";

import axios from 'axios';
import {EventBus} from "../events";

export default {
    install: function(Vue) {
        axios.interceptors.request.use(
            config =>
            {
                EventBus.$emit('show_spin');
                return config;
            },
            error =>
            {
                EventBus.$emit('hide_spin');
                if (error.status === 401)
                    VueRouter.push('/');
                else
                    throw error;
            }
        );
        axios.interceptors.response.use(
            response =>
            {
                EventBus.$emit('hide_spin');
                return response;
            },
            error =>
            {
                EventBus.$emit('hide_spin');
                return new Promise(function(resolve,reject)
                {
                    throw error;
                });
            }
        );
    }
}
